function Interests(){
    return (
        <div className="interests">
        <h4 className="section-title">Interests</h4>
        <p className="section-content">
        Food expert. Music scholar. Reader. Internet fanatic. Bacon buff.
        Entrepreneur. Travel geek. Pop culture ninja. Coffee fanatic.
        </p>
    </div>
    );
}
export default Interests;